export default function uniqueArrayOfObjects(arr, key) {
  // store the comparison values in array
  const result = arr.reduce((a, b) => {
    // store the indexes of the unique objects
    if (a.findIndex(x => x[key] === b[key]) === -1) {
      a.push(b);
    }
    return a;
  }, []);

  return result;
}
